import React from 'react'
import styles from "./AdBannerAccessibilitytoolbar.module.scss"
import SiteIcon from "../../assets/images/site-icon.svg"
import SiteIcon1 from "../../assets/images/siteicon1.png"
import SiteIcon2 from "../../assets/images/siteicon2.png"
function Blog(props) {
  return (
   <>
   <div className={styles.section_blog}>
     <div className={`${styles.container} container`}>
       <a href={props.url || "#"}>
         <div className={styles.blog_wrapper}>
          <div className={styles.blog_inner_wrapper}>
            <div className={styles.left_blog_contents}>
              <div className={styles.text_main_wrapper}>
                  <h2><span>1 in 6 people</span> in the UK have a Disability</h2>
                  <p>Ensure your website is truly accessible for everybody</p>
              </div>
                <div className={styles.blog_free_subscription}>
                  <p>FREE subscription. No contract. <span>Install in minutes.</span></p>
                </div>
            </div>
              <div className={styles.right_blog_contents}>
                  <div className={styles.text_icons}>
                  <img className={styles.icons1} src={SiteIcon1} alt="Site Icon" />
                  <img className={styles.icons2} src={SiteIcon2} alt="Site Icon" />
                  </div>
                  <div className={styles.wrapper_btn}>
                    <a href={props.url || "#"}>
                      JOIN FREE
                    </a>
                  </div>
              </div>
          </div>
        </div>
       </a>
    </div>
   </div>
   </>
  )
}

export default Blog
